import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { CreateOrderDialogMode } from "../createOrderTypes"

export type OrderContextState = {
    mode: CreateOrderDialogMode
    orderId?: number
}

export type OrderFormStatus = {
    meetingServiceId?: number | null
    resourceBookingId?: number | null
    isFullInitOrder: boolean
}

export function computeOrderFormStatus(orderDetails?: MeetingServiceOrder): OrderFormStatus {
    if (!orderDetails) return { meetingServiceId: null, resourceBookingId: null, isFullInitOrder: false }

    const orderSummary = orderDetails?.orderSummary
    const hasMeetingService = !!orderSummary?.hasCatering
    const hasResourceBooking = !!orderSummary?.hasBooking
    const currentId = orderDetails?.id ?? null

    if (hasMeetingService && hasResourceBooking) {
        return {
            meetingServiceId: null,
            resourceBookingId: null,
            isFullInitOrder: true,
        }
    }

    if (hasMeetingService && !hasResourceBooking) {
        return { meetingServiceId: currentId, resourceBookingId: null, isFullInitOrder: false }
    }
    if (!hasMeetingService && hasResourceBooking) {
        return { meetingServiceId: null, resourceBookingId: currentId, isFullInitOrder: false }
    }
    return { meetingServiceId: null, resourceBookingId: null, isFullInitOrder: false }
}
